import React, { useState } from 'react';
import { NoteIcon } from '@/src/components/icons';
import { Card, CardHeader, CardContent, CardTitle } from '@/src/components/ui/card';
import { Button } from '@/src/components/ui/button';

const PropertyNoteEditor = ({ propertyId, note, onSave, onDelete }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(note || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    const success = await onSave(propertyId, draft);
    setSaving(false);
    if (success) {
      setEditing(false);
    }
  };

  const handleCancel = () => {
    setDraft(note || '');
    setEditing(false);
  };

  const handleDelete = async () => {
    setSaving(true);
    const success = await onDelete(propertyId);
    setSaving(false);
    if (success) {
      setDraft('');
      setEditing(false);
    }
  };

  const handleEdit = () => {
    setDraft(note || '');
    setEditing(true);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center text-lg">
          <NoteIcon className="w-5 h-5" />
          <span className="ml-2">Private Note</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {editing ? (
          <div className="space-y-3">
            <textarea
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder="Add your notes about this property..."
              className="w-full min-h-[120px] p-3 border border-input rounded-md bg-background text-foreground text-sm resize-y focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
              autoFocus
            />
            <div className="flex items-center gap-2">
              <Button
                onClick={handleSave}
                disabled={saving}
                size="sm"
              >
                {saving ? 'Saving...' : 'Save'}
              </Button>
              <Button
                onClick={handleCancel}
                disabled={saving}
                variant="outline"
                size="sm"
              >
                Cancel
              </Button>
              {note && (
                <Button
                  onClick={handleDelete}
                  disabled={saving}
                  variant="outline"
                  size="sm"
                  className="ml-auto text-red-600 hover:text-red-700 hover:bg-red-50"
                >
                  Delete Note
                </Button>
              )}
            </div>
          </div>
        ) : note ? (
          <div>
            <p className="text-sm text-foreground whitespace-pre-wrap mb-3">{note}</p>
            <Button onClick={handleEdit} variant="outline" size="sm">
              <NoteIcon className="w-4 h-4 mr-1" />
              Edit Note
            </Button>
          </div>
        ) : (
          <Button onClick={handleEdit} variant="outline" size="sm">
            <NoteIcon className="w-4 h-4 mr-1" />
            Add Note
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default PropertyNoteEditor;
